function Footer() {
    this.preventCheck = false;

    // Set the footer visibility
    window.addEventListener('scroll', this.setFooterVisibility.bind(this));
    this.setFooterVisibility();

    Barba.Dispatcher.on('initStateChange', _ => {
        this.preventCheck = true;
    });

    Barba.Dispatcher.on('transitionCompleted', _ => {
        this.preventCheck = false;
        this.setFooterVisibility();
    });
};

Footer.prototype.setFooterVisibility = function() {
    if (!this.preventCheck) {
        if (document.body.offsetHeight > 0 && window.scrollY + window.innerHeight >= document.body.offsetHeight - 100) document.body.classList.add('bottom-pushup');
        else document.body.classList.remove('bottom-pushup');
    }
};